<template>
  <div class="cardContainer">
    <router-link v-for="tournament in myOrganizingTournaments"
       :key="tournament.tournamentId"
       :tournament="tournament" :to="/tournaments/ + tournament.tournamentId" class="card">
      <div class="card-header"><img src="@/assets/img/CA_Tournament_black.png" class="mini_logo" /> {{ tournament.name }} </div>
      <div class="card-details"> {{ tournament.edition }} </div>
    </router-link> 

    <router-link v-for="tournament in myTournaments"
       :key="tournament.tournamentId"
       :tournament="tournament" :to="/tournaments/ + tournament.tournamentId" class="card">
      <div class="card-header"><img src="@/assets/img/CA_Tournament_black.png" class="mini_logo" /> {{tournament.name}} </div>
      <div class="card-details"> {{ tournament.edition }} </div>
    </router-link> 

    <router-link v-for="club in myClubs"
       :key="club.clubId"
       :club="club" :to="/clubs/ + club.clubId" class="card">
      <div class="card-header"><img src="@/assets/img/CA_Club_black.png" class="mini_logo" />{{club.name}}</div>
    </router-link> 

  </div>
</template>

<script>

import {RestAPI} from "@aws-amplify/api-rest";

const apiName = 'api';
const myInit = { 
  response: false, 
};

//This component is only shown when the user is loggedin. 
export default {
  name: 'Involvements',
  data: function () {
    return {
      myOrganizingTournaments: [],
      myTournaments: [],
      myself: {},
      myClubs: [],
      playingTournaments: false,
      organizingTournaments: false
    }
  },
  beforeMount() {
    this.loadMyself();
    console.log("myself: " + JSON.stringify(this.myself));
    console.log("PersonId: " + JSON.stringify(this.myself.personId));
    if (this.$CAUser.getPersonId() != -1) {
      this.loadMyOrganizingTournaments();
      this.loadMyTournaments();
      this.loadMyClubs();
    }
  },
  methods: {
    loadMyself() {
      this.myself = this.$CAUser.getChessUser();
    },

    loadMyClubs() {
      let that = this
      let completePath = "/club?personId=" + this.$CAUser.getPersonId();
      RestAPI
        .get(apiName, completePath, myInit)
        .then(response => {
          console.log("my clubs: " + JSON.stringify(response));
          that.myClubs = response;
        })
        .catch(error => {
          if (error.status !== 404) {
            console.log("ERROR", JSON.stringify(error));
          }
        });
    },

    loadMyTournaments() {
      let that = this
      let completePath = "/tournament?personId=" + this.$CAUser.getPersonId();
      RestAPI
        .get(apiName, completePath, myInit)
        .then(response => {
          console.log("my tournaments: " + JSON.stringify(response));
          if (that.myOrganizingTournaments.length > 0 ) {
            var arrayWithoutDoubles = [];
            var tournaments = response;
            that.playingTournaments = tournaments.length > 0;
            tournaments.forEach(function (tournament) {
              var tournamentDouble = this.myTournaments.filter(function(elem){
                console.log("comparing: " + tournament.tournamentId + " to " + elem.tournamentId );
                if (elem.tournamentId == tournament.tournamentId) return elem;
              });
              console.log("double: " + JSON.stringify(tournamentDouble));
              if (tournamentDouble.length == 0) {
                arrayWithoutDoubles.push(tournament);
              }
            });
          
            that.myTournaments = arrayWithoutDoubles;
          } else {
            that.playingTournaments = that.myTournaments.length > 0;
            that.myTournaments = response;
          }
        })
        .catch(error => {
          if (error.status !== 404) {
            console.log("ERROR", JSON.stringify(error));
          }
        });
    },

    loadMyOrganizingTournaments() {
      let that = this
      let completePath = "/tournament?managerId=" + this.$CAUser.getPersonId();
      console.log("organized URL: " + completePath);
      RestAPI
        .get(apiName, completePath, myInit)
        .then(response => {
          console.log("organized: " + JSON.stringify(response));
          if (that.myTournaments.length > 0 ) {
            var arrayWithoutDoubles = [];
            var organizingTournaments = response;
            that.organizingTournaments = organizingTournaments.length > 0;
            var twoYearsAgo = new Date();
            twoYearsAgo.setFullYear(twoYearsAgo.getFullYear() - 2);
            organizingTournaments.forEach(function (tournament) {
              var tournamentEndDate = new Date(tournament.endDate);
    
              if (tournamentEndDate >= twoYearsAgo) {
                var tournamentDouble = this.myTournaments.filter(function(elem){
                  console.log("comparing: " + tournament.tournamentId + " to " + elem.tournamentId );
                  if (elem.tournamentId == tournament.tournamentId) return elem;
                });
                console.log("double: " + JSON.stringify(tournamentDouble));
                if (tournamentDouble.length == 0) {
                  arrayWithoutDoubles.push(tournament);
                }
              }
            });
          
            that.myOrganizingTournaments = arrayWithoutDoubles;
          } else {
            that.myOrganizingTournaments = response;
            that.organizingTournaments = that.myOrganizingTournaments.length > 0;
          }
})
        .catch(error => {
          if (error.status !== 404) {
            console.log("ERROR", JSON.stringify(error));
          }
        });
    },
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>
